import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const names = ['Ana', 'Pedro', 'Sofía', 'Diego', 'Camila', 'Mateo', 'Isabella', 'Santiago', 'Valentina', 'Lucas'];
const locations = ['Buenos Aires, Argentina', 'Lima, Perú', 'Bogotá, Colombia', 'CDMX, México', 'Santiago, Chile', 'Madrid, España', 'Montevideo, Uruguay', 'Quito, Ecuador'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    location: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomLocation = locations[Math.floor(Math.random() * locations.length)];
      setCurrentBuyer({
        name: randomName,
        location: randomLocation
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 3000);
    // Random interval between 8-12 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * 4000) + 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-218">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm" data-id="element-219">
          <div className="glass-card rounded-xl p-4 shadow-2xl border-l-4 border-l-brand-green flex items-start space-x-3" data-id="element-220">
            <div className="bg-brand-green/20 p-2 rounded-full mt-0.5" data-id="element-221">
              <CheckCircle2 className="w-5 h-5 text-brand-green" data-id="element-222" />
            </div>
            <div data-id="element-223">
              <p className="text-sm text-gray-300" data-id="element-224">
                <span className="font-bold text-white" data-id="element-225">
                  {currentBuyer.name}
                </span>{' '}
                de {currentBuyer.location}
              </p>
              <p className="text-xs text-brand-gold mt-1 font-medium" data-id="element-226">
                acaba de comprar este producto.
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}